import { client } from '../../../../../common-utils/libraries/axios/axios';
import SESSION from '../apiUrls';

const mutationSendMfaDeactivationMail = (OnSuccess, OnError) => {
    return {
        mutationFn: ({ landingPage, token }) => {
            const url = token ? SESSION.DEACTIVATE_MFA_AT_LOGIN.url : SESSION.SEND_MFA_DEACTIVATION_MAIL.url;
            const payload = {
                landingPage: landingPage
            };
            if (token) {
                payload.token = token;
            }
            return client.post(url, payload);
        },
        // onError: (error, variables, context)
        onError: () => {
            OnError();
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            OnSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationSendMfaDeactivationMail;